import { render, staticRenderFns } from "./EditCommunityPick.vue?vue&type=template&id=3a91907c&"
import script from "./EditCommunityPick.vue?vue&type=script&lang=js&"
export * from "./EditCommunityPick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports